module.exports = __webpack_public_path__ + "static/media/g-icon-delete_gray.36d37efe.svg";